import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const NEXT = 'next'
export const SAMPLE_SIZE = 'sample size'
export const WANTED_COMPLETES = 'wanted completes'
export const LOADING = 'loading'
export const SAVE = 'save'
export const QUOTA = 'quota'
export const CHOOSE = 'choose'
export const COMPLETE = 'complete'
export const VALIDATION_COMPLETE = 'validation complete'
export const DISTRIBUTE_EQUALLY = 'distribute equally'
export const PLACEHOLDER_COUNTRY = 'placeholder country'
export const SURVEY_UPDATED = 'survey updated'

export default {
  [PORTUGUESE]: {
    [NEXT]: 'Próximo',
    [SAMPLE_SIZE]: 'Tamanho da Amostra',
    [WANTED_COMPLETES]: 'Número de completas desejadas',
    [LOADING]: 'Carregando',
    [SAVE]: 'Salvar',
    [QUOTA]: 'Cotas',
    [CHOOSE]: 'Escolher',
    [COMPLETE]: 'Completa',
    [VALIDATION_COMPLETE]: 'A soma deve ser igual ao total do número de completos',
    [DISTRIBUTE_EQUALLY]: 'Distribuir Igualmente',
    [PLACEHOLDER_COUNTRY]: 'Adicionar cota ao país',
    [SURVEY_UPDATED]: 'Pesquisa atualizada',
  },

  [ENGLISH]: {
    [NEXT]: 'Next',
    [SAMPLE_SIZE]: 'Sample Size',
    [WANTED_COMPLETES]: 'Number of wanted completes',
    [LOADING]: 'Loading',
    [SAVE]: 'Save',
    [QUOTA]: 'Quota',
    [CHOOSE]: 'Choose',
    [COMPLETE]: 'Complete',
    [VALIDATION_COMPLETE]: 'The sum must equal the total of number of completes',
    [DISTRIBUTE_EQUALLY]: 'Distribute Equally',
    [PLACEHOLDER_COUNTRY]: 'Add quota to country',
    [SURVEY_UPDATED]: 'Survey updated',
  },

  [SPANISH]: {
    [NEXT]: 'Próximo',
    [SAMPLE_SIZE]: 'Tamaño de la Muestra',
    [WANTED_COMPLETES]: 'Numero de encuestas completas',
    [LOADING]: 'Cargando',
    [SAVE]: 'Salvar',
    [QUOTA]: 'Cuota',
    [CHOOSE]: 'Escoger',
    [COMPLETE]: 'Completa',
    [VALIDATION_COMPLETE]: 'La suma debe ser igual al total del número de completos',
    [DISTRIBUTE_EQUALLY]: 'Distribuir Equitativamente',
    [PLACEHOLDER_COUNTRY]: 'Agregar cuota al país',
    [SURVEY_UPDATED]: 'Encuesta actualizada',
  },
}
